import { getTransform } from "./qaConfig"

const getUser_CRUD_Config = {
  ...getTransform("dk_user_create_button"),
  ...getTransform("dk_user_submit_button"),
  ...getTransform("dk_user_cancel_button"),
  ...getTransform("dk_user_edit_button"),
  ...getTransform("dk_user_basic_details_heading_label"),
  ...getTransform("dk_user_profile_image_upload_button"),
  ...getTransform("dk_user_profile_image_delete_close_icon"),
  ...getTransform("dk_user_title_common_input"),
  ...getTransform("dk_user_title_common_error"),
  ...getTransform("dk_user_firstname_common_input"),
  ...getTransform("dk_user_firstname_common_error"),
  ...getTransform("dk_user_lastname_common_input"),
  ...getTransform("dk_user_lastname_common_error"),
  ...getTransform("dk_user_title_first_last_name_value_label"),
  ...getTransform("dk_user_title_role_chip_label"),
  ...getTransform("dk_user_role_common_key_label"),
  ...getTransform("dk_user_role_accessType_common_input"),
  ...getTransform("dk_user_role_accessType_value_label"),
  ...getTransform("dk_user_role_common_input"),
  ...getTransform("dk_user_role_common_error"),
  ...getTransform("dk_user_role_value_label"),
  ...getTransform("dk_user_gender_common_key_label"),
  ...getTransform("dk_user_gender_common_input"),
  ...getTransform("dk_user_gender_value_label"),
  ...getTransform("dk_user_emailAddress_common_key_label"),
  ...getTransform("dk_user_emailAddress_common_input"),
  ...getTransform("dk_user_emailAddress_common_error"),
  ...getTransform("dk_user_emailAddress_value_label"),
  ...getTransform("dk_user_phoneNumber_common_dropdown"),
  ...getTransform("dk_user_phoneNumber_common_key_label"),
  ...getTransform("dk_user_phoneNumber_common_input"),
  ...getTransform("dk_user_phoneNumber_common_error"),
  ...getTransform("dk_user_phoneNumber_value_label"),
  ...getTransform("dk_user_storeNumber_common_key_label"),
  ...getTransform("dk_user_storeNumber_common_input"),
  ...getTransform("dk_user_storeNumber_common_error"),
  ...getTransform("dk_user_storeNumber_value_label"),
  ...getTransform("dk_user_devicePin_common_key_label"),
  ...getTransform("dk_user_devicePin_common_input"),
  ...getTransform("dk_user_devicePin_common_error"),
  ...getTransform("dk_user_devicePin_value_label"),
  ...getTransform("dk_user_devicePin_edit_icon"),
  ...getTransform("dk_user_devicePin_visibilityOff_icon"),
  ...getTransform("dk_user_devicePin_visibility_icon"),
  ...getTransform("dk_user_addressLine1_common_key_label"),
  ...getTransform("dk_user_addressLine1_common_input"),
  ...getTransform("dk_user_addressLine1_common_error"),
  ...getTransform("dk_user_addressLine1_value_label"),
  ...getTransform("dk_user_addressLine2_common_key_label"),
  ...getTransform("dk_user_addressLine2_common_input"),
  ...getTransform("dk_user_addressLine2_common_error"),
  ...getTransform("dk_user_addressLine2_value_label"),
  ...getTransform("dk_user_country_common_key_label"),
  ...getTransform("dk_user_country_common_input"),
  ...getTransform("dk_user_country_common_error"),
  ...getTransform("dk_user_country_value_label"),
  ...getTransform("dk_user_state_common_key_label"),
  ...getTransform("dk_user_state_common_input"),
  ...getTransform("dk_user_state_common_error"),
  ...getTransform("dk_user_state_value_label"),
  ...getTransform("dk_user_city_common_key_label"),
  ...getTransform("dk_user_city_common_input"),
  ...getTransform("dk_user_city_common_error"),
  ...getTransform("dk_user_city_value_label"),
  ...getTransform("dk_user_zipCode_common_key_label"),
  ...getTransform("dk_user_zipCode_common_input"),
  ...getTransform("dk_user_zipCode_common_error"),
  ...getTransform("dk_user_zipCode_value_label"),
  ...getTransform("dk_user_dialog_authentiation_required_key_label"),
  ...getTransform("dk_user_dialog_title_first_last_name_label"),
  ...getTransform("dk_user_dialog_password_label"),
  ...getTransform("dk_user_dialog_password_common_input"),
  ...getTransform("dk_user_dialog_password_common_error"),
  ...getTransform("dk_user_dialog_authenticate_common_button"),
  ...getTransform("dk_user_dialog_cancel_button"),
  ...getTransform("dk_user_rolename_permission_mapping_label"),
  ...getTransform("dk_user_accesstype_application_header_label"),
  ...getTransform("dk_user_list_create_button")




}

export { getUser_CRUD_Config }
